import globalConfig from './globalConfig';
import { getStoreUrlParams } from '@utiles/index';

export const IS_PWA =
  globalConfig.getHrefParam('mode') === 'pwa' ||
  getStoreUrlParams()?.mode === 'pwa';

// 获取从活动页面跳转支付页的然后保存快捷方式时存下的scid
// 增加cid参数
export const getPwaActivityScidAndCid = () => {
  try {
    if (IS_PWA) {
      const pwaActivityScidStr = window.localStorage.getItem('pwaActivityScid');
      if (!pwaActivityScidStr) return '';
      const pwaActivityScidObj = JSON.parse(pwaActivityScidStr);
      return {
        scid: pwaActivityScidObj?.scid || '',
        cid: pwaActivityScidObj?.cid || ''
      };
    }
    return { scid: '', cid: '' };
  } catch (e) {
    console.error(e);
    return { scid: '', cid: '' };
  }
};
// 更新对象的scid值和cid值
export const updateObjScidAndCidOnPwa = data => {
  if (!data) return data;
  if (!IS_PWA) return data;
  const scidObj = getPwaActivityScidAndCid();
  try {
    data.scid = scidObj.scid || data?.scid || '';
    data.cid = scidObj.cid || data?.cid || '';
    return data;
  } catch (e) {
    console.error(e);
    return data;
  }
};
